import {useCallback} from 'react';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {QuestionParameters} from "../../../../../../../../types/QuestionParameters";
import {
    getDefaultSortingForParametersTable,
    nameSortComparator,
    parameterValueFormatter
} from "../../../../utils/tableUtils";
import {getCommonColumnProperties} from "../../../../../../utils/tableUtils";
import {v4 as uuid} from "uuid";

interface DisplayParametersProps {
    parameters: QuestionParameters[];
}

const baseColumns: GridColDef[] = [
    {field: 'name', sortComparator: nameSortComparator},
    {field: 'status'},
    {field: 'locEap', valueFormatter: parameterValueFormatter},
    {field: 'locPsd', valueFormatter: parameterValueFormatter},
    {field: 'scaleEap', valueFormatter: parameterValueFormatter},
    {field: 'scalePsd', valueFormatter: parameterValueFormatter},
    {field: 'guessingEap', valueFormatter: parameterValueFormatter},
    {field: 'guessingPsd', valueFormatter: parameterValueFormatter}
];
const columns: GridColDef[] = baseColumns.map(cell => ({...getCommonColumnProperties({flex: 1}), ...cell}));

export function DisplayParameters({parameters}: DisplayParametersProps) {
    const getRows = useCallback((params: QuestionParameters[]) => {
        return params.map((p: QuestionParameters) => {
            return Object.assign({'id': uuid()}, p)
        });
    }, []);

    return (
        <div>
            <h2>Parameters that have been uploaded</h2>
            <DataGrid
                rows={getRows(parameters)}
                columns={columns}
                initialState={{
                    pagination: { paginationModel: { pageSize: 20 } },
                    sorting: { sortModel: getDefaultSortingForParametersTable() },
                }}
                pageSizeOptions={[10, 20, 50, 100]}
                autoHeight={true}
                disableRowSelectionOnClick={true}
            />
        </div>
    )
}
